module.exports = __webpack_public_path__ + "img/Vermutete_Gefahr_durch_Explosivstoffe.002eac47.svg";